// @flow
import BaseModel from "../base/BaseModel";

import { TIMEVERSION_FILTER_NAME } from "../../constants/Constants";
import LinkCollection from "../links/LinkCollection";

import type LinkModel from "../links/LinkModel";

/**
 */
export default class ProcessStatusSettingsModel extends BaseModel {
  /**
   */
  get concequenceType(): string {
    return this.getContribution("consequenceType", "").toLowerCase();
  }

  /**
   */
  get transition(): string {
    return this.getContribution("transition", "").toLowerCase();
  }

  /**
   */
  get isApplicable(): boolean {
    return this.getData("applicable", false);
  }

  /**
   */
  get isCompleted(): boolean {
    return this.getData("completed", false);
  }

  /**
   */
  get isNeeded(): boolean | null {
    const needed = this.getData("needed", "unknown");

    if (needed === "unknown") {
      return null;
    }

    return needed === "true";
  }

  /**
   */
  get state(): string | null {
    return this.getData("state");
  }

  /**
   */
  get canComplete(): boolean | null {
    return this.getData("canComplete");
  }

  /**
   */
  get links(): LinkCollection {
    return new LinkCollection(this.contributions._links);
  }

  /**
   */
  get referenceDate(): ISO_DATE {
    return new Date().toISOString().split("T")[0];
  }

  /**
   * Retrieve concept link of attribute when available
   */
  get conceptLink(): LinkModel | null {
    const conceptLink = this.links.getLinkByKey("concept");
    if (conceptLink !== null) {
      conceptLink.href = conceptLink.href.addParameter(
        TIMEVERSION_FILTER_NAME,
        this.referenceDate,
      );

      conceptLink.isCacheable = true;
    }

    return conceptLink;
  }
}
